var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-dialog",
    {
      style: _vm.$vuetify.breakpoint.mdAndDown ? "x-overflow: hidden" : "",
      attrs: { fullscreen: _vm.$vuetify.breakpoint.mdAndDown, width: "90vw" },
      model: {
        value: _vm.dialog,
        callback: function($$v) {
          _vm.dialog = $$v
        },
        expression: "dialog"
      }
    },
    [
      _c(
        "v-card",
        { staticClass: "background", attrs: { tile: "" } },
        [
          _c("action-titlebar", {
            attrs: { action: _vm.action, mech: _vm.mech },
            on: {
              hide: function($event) {
                return _vm.hide()
              }
            }
          }),
          _vm._v(" "),
          _c(
            "v-card-text",
            { staticClass: "pt-4" },
            [
              _c("cc-active-synergy", {
                staticClass: "mb-n4",
                attrs: {
                  locations: _vm.action.SynergyLocations,
                  mech: _vm.mech
                }
              }),
              _vm._v(" "),
              _c(
                "v-row",
                { attrs: { justify: "center", align: "center" } },
                [
                  _c(
                    "v-col",
                    [
                      _c("action-detail-expander", {
                        attrs: { action: _vm.action }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "v-col",
                    { attrs: { cols: "auto" } },
                    [
                      _c(
                        "v-btn",
                        {
                          attrs: {
                            large: "",
                            tile: "",
                            dark: "",
                            block: "",
                            disabled: _vm.actionFree,
                            color:
                              _vm.action.Color +
                              " " +
                              (_vm.actionCost ? "lighten-1" : "")
                          },
                          on: {
                            click: function($event) {
                              _vm.actionCost = !_vm.actionCost
                            }
                          }
                        },
                        [
                          _c("v-icon", { attrs: { left: "" } }, [
                            _vm._v(_vm._s(_vm.action.Icon))
                          ]),
                          _vm._v(
                            "\n            " +
                              _vm._s(_vm.action.Name) +
                              "\n          "
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      !_vm.fulltech && _vm.action.Activation !== "Free"
                        ? _c(
                            "v-btn",
                            {
                              attrs: {
                                small: "",
                                tile: "",
                                dark: "",
                                block: "",
                                disabled: _vm.actionCost,
                                color:
                                  "action--free " +
                                  (_vm.actionFree ? "lighten-1" : "")
                              },
                              on: {
                                click: function($event) {
                                  _vm.actionFree = !_vm.actionFree
                                }
                              }
                            },
                            [
                              _c("v-icon", { attrs: { left: "", small: "" } }, [
                                _vm._v("cci-free-action")
                              ]),
                              _vm._v("\n            Free Action\n            "),
                              _c(
                                "cc-tooltip",
                                {
                                  attrs: {
                                    inline: "",
                                    content:
                                      "Special rules or equipment may allow you to " +
                                      _vm.action.Name +
                                      " as a Free Action. Using this button will commit the action without spending a Quick Action this turn"
                                  }
                                },
                                [
                                  _c(
                                    "v-icon",
                                    {
                                      staticClass: "fadeSelect",
                                      attrs: { right: "", small: "" }
                                    },
                                    [_vm._v("mdi-information-outline")]
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        : _vm._e()
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "v-slide-x-reverse-transition",
                [
                  _vm.actionFree || _vm.actionCost
                    ? _c(
                        "v-row",
                        { attrs: { justify: "center", align: "center" } },
                        [
                          _c(
                            "v-col",
                            {
                              staticClass: "mt-n5",
                              attrs: { lg: "auto", md: "12" }
                            },
                            [
                              _c(
                                "v-row",
                                {
                                  staticClass: "text-center mb-n3",
                                  attrs: {
                                    dense: "",
                                    justify: "start",
                                    align: "start"
                                  }
                                },
                                [
                                  _c(
                                    "v-col",
                                    {
                                      staticClass: "mx-8",
                                      attrs: { cols: "auto" }
                                    },
                                    [
                                      _c(
                                        "div",
                                        { staticClass: "overline mb-n2" },
                                        [_vm._v("Tech Attack Roll")]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        {
                                          staticClass: "heading text--text",
                                          staticStyle: { "font-size": "24pt" }
                                        },
                                        [
                                          _c(
                                            "v-icon",
                                            {
                                              staticClass: "mr-n1",
                                              attrs: { "x-large": "" }
                                            },
                                            [_vm._v("mdi-dice-d20-outline")]
                                          ),
                                          _vm._v(
                                            "\n                  " +
                                              _vm._s(
                                                "" +
                                                  (_vm.mech.TechAttack >= 0
                                                    ? "+"
                                                    : "") +
                                                  _vm.mech.TechAttack
                                              ) +
                                              "\n                "
                                          )
                                        ],
                                        1
                                      )
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "v-col",
                                    {
                                      staticClass: "mx-8",
                                      attrs: { cols: "auto" }
                                    },
                                    [
                                      _c(
                                        "div",
                                        { staticClass: "overline mb-n3" },
                                        [_vm._v("vs. Target")]
                                      ),
                                      _vm._v(" "),
                                      _c("v-icon", {
                                        attrs: { "x-large": "" },
                                        domProps: {
                                          innerHTML: _vm._s("cci-edef")
                                        }
                                      }),
                                      _vm._v(" "),
                                      _c("div", {
                                        staticClass:
                                          "overline font-weight-bold mt-n2",
                                        domProps: {
                                          innerHTML: _vm._s("E-Defense")
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "v-col",
                            { staticClass: "ml-auto", attrs: { cols: "auto" } },
                            [
                              _c(
                                "v-row",
                                { attrs: { dense: "", justify: "end" } },
                                [
                                  _c(
                                    "v-col",
                                    {
                                      staticClass:
                                        "ml-auto px-12 mr-n10 panel dual-sliced",
                                      staticStyle: { height: "70px" },
                                      attrs: { cols: "auto" }
                                    },
                                    [
                                      _c(
                                        "div",
                                        { staticClass: "overline mt-n2 pl-1" },
                                        [_vm._v("Accuracy")]
                                      ),
                                      _vm._v(" "),
                                      _c("v-text-field", {
                                        staticClass: "hide-input-spinners",
                                        staticStyle: { width: "115px" },
                                        attrs: {
                                          type: "number",
                                          "append-outer-icon":
                                            "mdi-plus-circle-outline",
                                          "append-icon": "cci-accuracy",
                                          "prepend-icon":
                                            "mdi-minus-circle-outline",
                                          color: "accent",
                                          dense: "",
                                          "hide-details": ""
                                        },
                                        on: {
                                          "click:append-outer": function(
                                            $event
                                          ) {
                                            _vm.accuracy < 99
                                              ? (_vm.accuracy += 1)
                                              : ""
                                          },
                                          "click:prepend": function($event) {
                                            _vm.accuracy > _vm.minAccuracy
                                              ? (_vm.accuracy -= 1)
                                              : ""
                                          },
                                          change: function($event) {
                                            _vm.accuracy = parseInt($event)
                                          }
                                        },
                                        model: {
                                          value: _vm.accuracy,
                                          callback: function($$v) {
                                            _vm.accuracy = $$v
                                          },
                                          expression: "accuracy"
                                        }
                                      })
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "v-col",
                                    {
                                      staticClass:
                                        "px-12 mr-n10 panel dual-sliced",
                                      staticStyle: { height: "70px" },
                                      attrs: { cols: "auto" }
                                    },
                                    [
                                      _c(
                                        "div",
                                        { staticClass: "overline mt-n2 pl-1" },
                                        [_vm._v("Difficulty")]
                                      ),
                                      _vm._v(" "),
                                      _c("v-text-field", {
                                        staticClass: "hide-input-spinners",
                                        staticStyle: { width: "115px" },
                                        attrs: {
                                          type: "number",
                                          "append-outer-icon":
                                            "mdi-plus-circle-outline",
                                          "append-icon": "cci-difficulty",
                                          "prepend-icon":
                                            "mdi-minus-circle-outline",
                                          color: "accent",
                                          dense: "",
                                          "hide-details": ""
                                        },
                                        on: {
                                          "click:append-outer": function(
                                            $event
                                          ) {
                                            _vm.difficulty < 99
                                              ? (_vm.difficulty += 1)
                                              : ""
                                          },
                                          "click:prepend": function($event) {
                                            _vm.difficulty > _vm.minDifficulty
                                              ? (_vm.difficulty -= 1)
                                              : ""
                                          },
                                          change: function($event) {
                                            _vm.difficulty = parseInt($event)
                                          }
                                        },
                                        model: {
                                          value: _vm.difficulty,
                                          callback: function($$v) {
                                            _vm.difficulty = $$v
                                          },
                                          expression: "difficulty"
                                        }
                                      })
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "v-col",
                                    {
                                      staticClass: "px-12 panel dual-sliced",
                                      staticStyle: { height: "70px" },
                                      attrs: { cols: "auto" }
                                    },
                                    [
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "overline mt-n2 mr-n6 pl-3"
                                        },
                                        [_vm._v("Tech Attack Roll")]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "v-row",
                                        { attrs: { "no-gutters": "" } },
                                        [
                                          _c(
                                            "v-col",
                                            { staticClass: "mr-n2 ml-n2" },
                                            [
                                              _c(
                                                "cc-tooltip",
                                                {
                                                  attrs: {
                                                    title: "Roll Tech Attack",
                                                    content:
                                                      _vm.rollResultTooltip
                                                  }
                                                },
                                                [
                                                  _c(
                                                    "v-btn",
                                                    {
                                                      staticClass: "mt-1 mr-n3",
                                                      attrs: {
                                                        icon: "",
                                                        small: "",
                                                        color: "accent"
                                                      },
                                                      on: {
                                                        click: _vm.rollSkill
                                                      }
                                                    },
                                                    [
                                                      _c(
                                                        "v-icon",
                                                        {
                                                          attrs: { large: "" }
                                                        },
                                                        [
                                                          _vm._v(
                                                            "mdi-dice-multiple"
                                                          )
                                                        ]
                                                      )
                                                    ],
                                                    1
                                                  )
                                                ],
                                                1
                                              )
                                            ],
                                            1
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "v-col",
                                            [
                                              _c("v-text-field", {
                                                staticClass:
                                                  "hide-input-spinners ml-n3",
                                                staticStyle: {
                                                  "max-width": "60px",
                                                  "margin-top": "-0.5px"
                                                },
                                                attrs: {
                                                  type: "number",
                                                  color: "accent",
                                                  dense: "",
                                                  "hide-details": ""
                                                },
                                                model: {
                                                  value: _vm.attackRoll,
                                                  callback: function($$v) {
                                                    _vm.attackRoll = $$v
                                                  },
                                                  expression: "attackRoll"
                                                }
                                              })
                                            ],
                                            1
                                          )
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    : _vm._e()
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "v-slide-x-reverse-transition",
                [
                  !!_vm.attackRoll
                    ? _c(
                        "v-row",
                        { staticClass: "mt-n2", attrs: { dense: "" } },
                        [
                          _c(
                            "v-col",
                            {
                              staticClass: "ml-auto",
                              attrs: { md: "6", lg: "3", xl: "2" }
                            },
                            [
                              _c(
                                "v-btn",
                                {
                                  staticClass: "primary",
                                  attrs: {
                                    tile: "",
                                    block: "",
                                    color:
                                      "primary " +
                                      (_vm.succeeded ? "lighten-1" : ""),
                                    disabled: _vm.failed
                                  },
                                  on: {
                                    click: function($event) {
                                      _vm.succeeded = !_vm.succeeded
                                    }
                                  }
                                },
                                [
                                  _vm._v(
                                    "\n              SUCCESS\n            "
                                  )
                                ]
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "v-col",
                            { attrs: { md: "6", lg: "3", xl: "2" } },
                            [
                              _c(
                                "v-btn",
                                {
                                  attrs: {
                                    tile: "",
                                    block: "",
                                    disabled: _vm.succeeded,
                                    color: _vm.failed ? "error" : ""
                                  },
                                  on: {
                                    click: function($event) {
                                      return _vm.fail()
                                    }
                                  }
                                },
                                [
                                  _vm._v(
                                    "\n              FAILURE\n            "
                                  )
                                ]
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    : _vm._e()
                ],
                1
              ),
              _vm._v(" "),
              _c("v-slide-x-reverse-transition", [
                _vm.succeeded
                  ? _c(
                      "div",
                      [
                        _c(
                          "v-row",
                          {
                            staticClass: "mt-2 mb-n2",
                            attrs: { "no-gutters": "", justify: "center" }
                          },
                          [
                            _c(
                              "v-col",
                              {
                                staticClass: "ml-auto",
                                staticStyle: { "max-width": "800px" },
                                attrs: { cols: "auto", align: "end" }
                              },
                              [
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "body-text stark--text text-left"
                                  },
                                  [
                                    _c("b", [_vm._v("Invasion Success")]),
                                    _vm._v(" "),
                                    _c("p", [
                                      _vm._v(
                                        "\n                  Your target takes\n                  "
                                      ),
                                      _c("b", [_vm._v("2 Heat")]),
                                      _vm._v(
                                        "\n                  , and you choose one of the following Invasion Options:\n                "
                                      )
                                    ])
                                  ]
                                )
                              ]
                            )
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "v-row",
                          { attrs: { dense: "", justify: "center" } },
                          _vm._l(_vm.actions, function(a, j) {
                            return _c(
                              "v-col",
                              {
                                key: "action_" + j,
                                staticStyle: { "min-width": "400px" },
                                attrs: { cols: "auto" }
                              },
                              [
                                _c(
                                  "v-card",
                                  {
                                    class:
                                      _vm.selected === a
                                        ? "optionSelect"
                                        : "optionFade",
                                    attrs: { tile: "", outlined: "" },
                                    on: {
                                      click: function($event) {
                                        return _vm.select(a)
                                      }
                                    }
                                  },
                                  [
                                    _c(
                                      "v-toolbar",
                                      {
                                        attrs: {
                                          color:
                                            _vm.selected === a
                                              ? "secondary"
                                              : "",
                                          dense: ""
                                        }
                                      },
                                      [
                                        _c(
                                          "v-toolbar-title",
                                          { staticClass: "px-n2 heading h3" },
                                          [
                                            _vm._v(
                                              "\n                    " +
                                                _vm._s(a.Name) +
                                                "\n                  "
                                            )
                                          ]
                                        )
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c("v-card-text", [
                                      _c("div", {
                                        staticClass: "body-text text--text",
                                        domProps: { innerHTML: _vm._s(a.Terse) }
                                      }),
                                      _vm._v(" "),
                                      _c("div", {
                                        staticClass: "flavor-text mt-1 mx-3",
                                        domProps: {
                                          innerHTML: _vm._s(a.Detail)
                                        }
                                      })
                                    ])
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          }),
                          1
                        )
                      ],
                      1
                    )
                  : _vm._e()
              ]),
              _vm._v(" "),
              _c(
                "v-slide-x-reverse-transition",
                [
                  _vm.failed || (_vm.succeeded && _vm.selected)
                    ? _c(
                        "v-row",
                        { staticClass: "mt-2", attrs: { "no-gutters": "" } },
                        [
                          _c(
                            "v-col",
                            {
                              staticClass: "ml-auto",
                              attrs: { cols: "auto", align: "end" }
                            },
                            _vm._l(_vm.skLog, function(s, i) {
                              return _c(
                                "v-fade-transition",
                                { key: "skLog_" + i },
                                [
                                  _vm.timer > 10 * i
                                    ? _c(
                                        "p",
                                        {
                                          staticClass:
                                            "flavor-text stark--text ma-0"
                                        },
                                        [
                                          _c("span", [
                                            _vm._v(
                                              "\n                  >//[\n                  "
                                            ),
                                            _c(
                                              "span",
                                              { staticClass: "accent--text" },
                                              [
                                                _vm._v(
                                                  "\n                    COMP/CON:\n                  "
                                                )
                                              ]
                                            ),
                                            _vm._v(
                                              "\n                  ] :\n                  "
                                            ),
                                            _c("span", [_vm._v(_vm._s(s))])
                                          ])
                                        ]
                                      )
                                    : _vm._e()
                                ]
                              )
                            }),
                            1
                          )
                        ],
                        1
                      )
                    : _vm._e()
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "v-slide-x-reverse-transition",
                [
                  _vm.finished
                    ? _c(
                        "v-row",
                        { attrs: { "no-gutters": "" } },
                        [
                          _c(
                            "v-col",
                            { staticClass: "ml-auto", attrs: { cols: "auto" } },
                            [
                              _c(
                                "cc-tooltip",
                                {
                                  attrs: {
                                    content:
                                      "Undo this action, refunding any cost it may have had"
                                  }
                                },
                                [
                                  _c(
                                    "v-btn",
                                    {
                                      staticClass: "fadeSelect",
                                      attrs: {
                                        "x-small": "",
                                        color: "primary"
                                      },
                                      on: { click: _vm.reset }
                                    },
                                    [
                                      _c(
                                        "v-icon",
                                        { attrs: { small: "", left: "" } },
                                        [_vm._v("mdi-reload")]
                                      ),
                                      _vm._v(
                                        "\n                UNDO\n              "
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    : _vm._e()
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c("v-slide-y-reverse-transition", [
            _vm.complete
              ? _c(
                  "div",
                  [
                    _c("v-divider"),
                    _vm._v(" "),
                    _c(
                      "v-card-actions",
                      [
                        _c("v-spacer"),
                        _vm._v(" "),
                        _c(
                          "v-btn",
                          {
                            attrs: { color: "primary", tile: "" },
                            on: {
                              click: function($event) {
                                _vm.dialog = false
                              }
                            }
                          },
                          [_vm._v("DISMISS")]
                        )
                      ],
                      1
                    )
                  ],
                  1
                )
              : _vm._e()
          ])
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }